<template>
  <v-app-bar title="Parcel">
    <template #prepend>
      <v-app-bar-nav-icon @click="getInternalValue = !getInternalValue">
        <v-img
          alt="Parcel Logo"
          cover
          min-height="48px"
          min-width="48px"
          src="../assets/icon_small.svg"
        />
      </v-app-bar-nav-icon>
    </template>
  </v-app-bar>
</template>

<script setup lang="ts">
  const props = defineProps({
    modelValue: {
      type: Boolean,
    },
  })

  const emit = defineEmits(['update:modelValue'])

  const getInternalValue = computed({
    // eslint-disable-next-line @stylistic/space-before-function-paren
    get() {
      return props.modelValue
    },
    // eslint-disable-next-line @stylistic/space-before-function-paren
    set(value: boolean) {
      return emit('update:modelValue', value)
    },
  })
</script>
